'use strict'

var conversionTracking = require('../conversionTracking/conversionTracking.js');

module.exports = (function () {
    /**
    * @ngdoc method
    * @name asyncForms
    * @description Initializes UmbracoForms with async submissions
    **/

    // Needs only be initialized once per page
    var initializeAsyncForms = function () {

        var $forms = $('.umbraco-forms-getours-async form');
        $forms.on('submit', function (e) {
            e.preventDefault();

            var $form = $(this);
            if ($form.data('submitted') === true) {
                // Previously submitted - don't submit again
            }
            else if ($form.valid()) {
                // Mark it so that the next submit can be ignored
                $form.data('submitted', true);

                // store wrapper for error message
                var $formParent = $form.parent();

                // store pop-up for thank you message
                var $popup = $form.closest('.form-popup');

                // Make ajax call form submission
                $.ajax({
                    url: $form.attr('action'),
                    type: 'POST',
                    cache: false,
                    data: $form.serialize(),
                    success: function (result) {
                        conversionTracking.pushFormEvent($form, 'success');
                        /*$formParent.html('<div class="umbraco-forms-submitmessage async-submit-message"><p>' + result + '</p></div>');*/
                        if ($popup && $popup.length > 0) {

                            // fix popup height to the current popup height value
                            //fixPopupHeight($form);
                            $popup.addClass('form-succes')

                            var $introduction = $popup.find('.form-introduction');
                            if ($introduction) {
                                $introduction.addClass('hide')
                            }

                            if ($formParent && $formParent.parent()) {
                                $formParent.parent().addClass('hide')
                            }

                            var $successMessage = $popup.find('.form-success-message');
                            if ($successMessage) {
                                $successMessage.removeClass('hide')
                            }
                        }

                        // Attempt to hide any buttons that may have opened this form in a popup
                        hidePopupButton($form);

                    },
                    error: function (result, status, err) {

                        conversionTracking.pushFormEvent($form, 'error');

                        console.log('async form submission error: ' + err);

                        var submitBtn = $form.find('input[type="submit"]');
                        submitBtn.hide();

                        var errorMessage = 'There was a problem with your form submission. Please reload the page and try again. Contact Grand European Travel for assistance if you need help.';
                        $formParent.append('<div class="umbraco-forms-submitmessage async-submit-message async-error-message"><p>' + errorMessage + '</p></div>');
                    }
                });
            }

            return this;
        });
    };

    var hidePopupButton = function ($form) {
        var $popupWrapper = $form.closest('.simple-popup.form-popup');
        if ($popupWrapper.length > 0) {
            var $popupTrigger = $('.form-popup-trigger[href=#' + $popupWrapper.attr('id') + ']');
            $popupTrigger.hide();
        }
    }

    // measure the popups height and fix the height at that value
    // when the form disappears, keep the popup that same size
    var fixPopupHeight = function ($form) {
        var $popupWrapper = $form.closest('.simple-popup.form-popup');
        var measuredHeight = $popupWrapper.height();
        $popupWrapper.height(measuredHeight);
    }

    // Return an object exposing the public items
    return {
        initialize: initializeAsyncForms
    };

}())